module.exports = __webpack_public_path__ + "img/reward-phone-wallet.8b54ccc1.png";